/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_fr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add, subtract, multiply and divide fractions with automatic simplification.`)
};

const es_fr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramienta gratuita de buscar y reemplazar. Reemplaza texto con coincidencia literal o expresión regular, opciones de sin distinción de mayúsculas y solo palabras completas. Se ejecuta en tu navegador.`)
};

const de_fr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloses Tool zum Suchen und Ersetzen. Ersetzen Sie Text mit wörtlicher oder regulärer Ausdrucks-Übereinstimmung, mit Optionen für Groß-/Kleinschreibung und ganze Wörter. Läuft in Ihrem Browser.`)
};

const nl_fr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis zoeken- en vervangingshulpmiddel. Vervang tekst met letterlijke of reguliere-expressiebijpassingen, niet-hoofdlettergevoelige en alleen-hele-woord-opties. Draait in uw browser.`)
};

const fr_fr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outil gratuit de recherche et remplacement. Remplacez le texte par correspondance littérale ou expression régulière, avec options insensibles à la casse et mot entier. Fonctionne dans votre navigateur.`)
};

const it_fr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strumento gratuito di ricerca e sostituzione. Sostituisci il testo con corrispondenza letterale o espressione regolare, con opzioni di ricerca senza distinzione tra maiuscole e minuscole e solo parola intera. Funziona nel tuo browser.`)
};

const pt_br2_fr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramenta gratuita de localizar e substituir. Substitua texto com correspondência literal ou por expressão regular, com opções de distinção de maiúsculas/minúsculas e palavra completa. Executa em seu navegador.`)
};

const pt_fr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramenta gratuita de procura e substituição. Substitua texto com correspondência literal ou de expressão regular, opções de insensibilidade a maiúsculas e palavras inteiras. Executa no seu navegador.`)
};

const ja_fr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の検索と置換ツール。文字列または正規表現で置換し、大文字小文字を区別しない、単語全体のみのオプションがあります。ブラウザで実行されます。`)
};

const zh_fr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的查找和替换工具。支持字面文本或正则表达式匹配替换文本，可选不区分大小写和仅匹配整个单词。在你的浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const fr_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.fr_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("fr_tool_description", locale)
	if (locale === "en") return en_fr_tool_description(inputs)
	if (locale === "es") return es_fr_tool_description(inputs)
	if (locale === "de") return de_fr_tool_description(inputs)
	if (locale === "nl") return nl_fr_tool_description(inputs)
	if (locale === "fr") return fr_fr_tool_description(inputs)
	if (locale === "it") return it_fr_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_fr_tool_description(inputs)
	if (locale === "pt") return pt_fr_tool_description(inputs)
	if (locale === "ja") return ja_fr_tool_description(inputs)
	return zh_fr_tool_description(inputs)
};